import { APIClient } from "../../helpers/apiClient";
import {
  GET_TEAMS,
  GET_TEAMS_SUCCESS,
  GET_TEAMS_FAILURE,
  ASSIGN_TEAM,
  ASSIGN_TEAM_SUCCESS,
  ASSIGN_TEAM_FAILURE,
  UNASSIGN_TEAM,
  UNASSIGN_TEAM_SUCCESS,
  UNASSIGN_TEAM_FAILURE,
  RESET_TEAM_SUCCESS,
  API_FAILED,
} from "./constants";

const apiClient = new APIClient();
const { get, post } = apiClient;

export const getTeams = (groupId) => async (dispatch) => {
  try {
    dispatch({
      type: GET_TEAMS,
      payload: { groupId },
    });

    const response = await get(`/v2/teams?groupId=${groupId}`);
    
    dispatch({
      type: GET_TEAMS_SUCCESS,
      payload: response,
    });

    return response;
  } catch (error) {
    dispatch({
      type: GET_TEAMS_FAILURE,
      payload: error.message,
    });
    dispatch({
      type: API_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

export const assignTeam = (contactId, teamId) => async (dispatch) => {
  try {
    dispatch({
      type: ASSIGN_TEAM,
      payload: { contactId, teamId },
    });

    const response = await post(`/contacts/${contactId}/assign-team`, {
      teamId: teamId
    });
    
    dispatch({
      type: ASSIGN_TEAM_SUCCESS,
      payload: response,
    });

    return response;
  } catch (error) {
    dispatch({
      type: ASSIGN_TEAM_FAILURE,
      payload: error.message,
    });
    dispatch({
      type: API_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

export const unassignTeam = (contactId) => async (dispatch) => {
  try {
    dispatch({
      type: UNASSIGN_TEAM,
      payload: { contactId },
    });

    const response = await post(`/contacts/${contactId}/unassign-team`);
    
    dispatch({
      type: UNASSIGN_TEAM_SUCCESS,
      payload: response,
    });

    return response;
  } catch (error) {
    dispatch({
      type: UNASSIGN_TEAM_FAILURE,
      payload: error.message,
    });
    dispatch({
      type: API_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

export const apiError = (error) => ({
  type: API_FAILED,
  payload: error,
});

export const resetTeamSuccess = () => ({
  type: RESET_TEAM_SUCCESS,
});
